export default [
	{
		path: '/token',
		name: 'token',
		meta: { granted: [] },
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/Token.vue')
	},
];